import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createPortal } from "react-dom";

import ImgPremium from '~/src/assets/premium.svg';

import Action from "../../Action";
import Divider from "../../Atoms/Divider";

import * as style from './style.module.css';

const ActionMenuItem = ({ action, title, icon, type = null }) => <Action action={action} className={`${style.userMenuAction} ${type === 'PREMIUM' ? style.userMenuActionPremium : ''} ${type === 'LOGOUT' ? style.logout : ''} ${type === 'ALERT' ? style.alert : ''}`}>
  {icon && type !== 'PREMIUM' && <FontAwesomeIcon icon={icon} />}
  {type === 'PREMIUM' && <img src={ImgPremium} alt="Premium" />}
  <span>{title}</span>
</Action>;

const ActionsMenu = ({ actions = [], isOpened, onClose = () => { }, position = 'TOP' }) => {
  return <>
    {createPortal(<>
      <div className={`${style.closeLayer} ${isOpened ? style.isOpened : ''}`} onClick={onClose} />
      <div className={`${style.userMenu} ${style?.[position.toLowerCase()]} ${isOpened ? style.isOpened : ''}`}>
        {actions.map((action, i) => {
          if (action.type === 'DIVIDER') {
            return <Divider key={i} />;
          }
          return <ActionMenuItem key={i} action={[action.action, onClose]} icon={action.icon} title={action.title} type={action.type} loading={action.loading || false} disabled={action.disabled || false} />;
        })}
      </div>
    </>, document.body)}
  </>;
};

export default ActionsMenu;
